import TagDescriptions from './tag-descriptions';

export default TagDescriptions;